module.exports = __webpack_public_path__ + "img/bm.ac46caeb.svg";